import React from "react";
import { connect } from "react-redux";
import { store } from "../../redux/store";
import { resetMiscData, setCallBackUrl } from './../../redux/misc-data/misc-data.action';
import authReducer from './../../redux/auth/auth.reducer';
import { resetBillPayData } from "../../redux/billpayDetails/billpay.action";
import { resetAeps } from "../../redux/aeps/aeps.action";
import { resetRecharge } from "../../redux/recharge/recharge.action";
import { resetRetailerKyc } from "../../redux/retailer-kyc-details/retailer-kyc-details.action";


class Logout extends React.Component{
    constructor(props){
        super(props);
        this.state={
			phoneNo: this.props.phone,
			password:'',
			otpRef:'',
			message:''
		}
    }

	

	

    componentDidMount(){
      localStorage.clear();
      setTimeout(() =>{
      store.dispatch(resetBillPayData);
      store.dispatch(resetAeps);
      store.dispatch(resetRecharge);
      store.dispatch(resetRetailerKyc);
      store.dispatch(resetMiscData);
      },600);
    }
	componentWillUnmount(){
    }
    render(){
     
    //  localStorage.setItem('callBackUrl',this.props.callBackUrl);
    //  var setCallBackUrl=localStorage.getItem('callBackUrl');
     
    //  console.log('callBackUrl...'+setCallBackUrl);
    return(
           
      <div>
         <centre><h1>User is logged out</h1></centre>
         {this.props.callBackUrl}
      </div>
      );
      } 
}

const mapStateToProps = (
	{ errorMessageReduce:{},
  authReduce:{callBackUrl}
	}
	) => ({
		callBackUrl
});

export default connect(mapStateToProps, null)(Logout);
